import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { BillingEventData } from '@/common/types/billing/event.type'
import { formatCardNumber, formatCurrency, formatDateTime, formatDecimal, formatUnit } from '@/common/utils/formatters'
import { transformToNumber } from '@/common/utils/transformers'
import CompanyEventTotalFee from '@/features/privateCompanies/components/companyConsumptionTotalFee'
import {
  eventableDetailsComponent,
  eventableTypeTranslations,
} from '@/features/privateCompanies/services/companyBillingEventTransformer'
import { UserEventData } from '@/features/privateCompanies/types/userEvents.type'
import { UserRoundIcon } from 'lucide-react'
import { createElement } from 'react'

export class EquipmentEventsTransformer {
  static tableTransformer() {
    return (userEvents: UserEventData[]) => {
      return userEvents.map((userEvent) => {
        const events = userEvent.eventable
        const data = events.refundable ?? events

        const clientBranch = data?.branch_name || data?.client_branch?.display_name

        return {
          protocol_number: userEvent.protocol_number ? `${userEvent.protocol_number}` : '',
          bill: 'Não implementado',
          type: eventableTypeTranslations[userEvent.eventable_type] || '',
          details: userEvent.eventable_type && eventableDetailsComponent[userEvent.eventable_type]
            ? createElement(eventableDetailsComponent[userEvent.eventable_type], { data: userEvent.eventable })
            : '--',
          total_amount: data.total_amount
            ? formatCurrency(
              transformToNumber({
                value: data.total_amount,
                invert: userEvent.eventable_type === 'Billing::Refund',
              })
            )
            : '',
          fee_total: userEvent.fee_total
            ? createElement(CompanyEventTotalFee, { data: userEvent as unknown as BillingEventData })
            : '',
          income_tax_total_amount: userEvent.income_tax_total ? formatCurrency(Number(userEvent.income_tax_total)) : '',
          
          branch: clientBranch || '',
          
          card: data?.card?.last_four_digits
            ? formatCardNumber(data.card.last_four_digits)
            : '',
          current_equipment_usage: data?.current_equipment_usage
            ? formatUnit(formatDecimal(data.current_equipment_usage, 0), 'kilometers')
            : '',
          equipment_license_plate: data?.card?.equipment_field_for_display_value || '',
          author: userEvent.author?.full_name
            ? (
              <div className="flex items-center gap-2">
                <ImageWithPlaceholder
                  alt={userEvent.author.full_name}
                  placeholderIcon={UserRoundIcon}
                  className="size-6"
                  iconClassName="size-4"
                />
                <p className="text-xs">{userEvent.author.full_name}</p>
              </div>
            )
            : '',
          created_at: userEvent.created_at ? formatDateTime(new Date(userEvent.created_at)) : '',
        }
      })
    }
  }
}